<template>
  <div id="menuBox">
    <div class="header-box">
      <div class="logo">自嗨启动器后台管理系统</div>
      <div class="info-box">
        <div class="btn-logout" @click="logout()">注销</div>
        <div class="user-name-label">
          <i class="el-icon-user-solid" style="margin-right: 5px;margin-left: 10px"></i>{{ info.realName }}
        </div>
      </div>
    </div>
    <div class="menu-box">
      <el-menu :default-active="activeIndex" class="el-menu-vertical-demo">
        <template v-for="item in menuList">
          <el-submenu :index="item.id" :key="item.id" v-if="item.children"
                      v-show="permission.indexOf(item.id) >= 0">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="menu.id" v-for="menu in item.children" v-show="permission.indexOf(menu.id) >= 0"
                            :key="menu.id" @click="gotoMenu(menu)">{{ menu.name }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item :index="item.id" v-if="!item.children" :key="item.id" @click="gotoMenu(item)"
                        v-show="permission.indexOf(item.id) >= 0">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div class="content-box">
      <router-view ref="routeNode"></router-view>
    </div>
  </div>
</template>

<script>

import {getMenuList} from "../utils/menu";
import request from '@/utils/request';
import {listToTree} from "@/utils/common";
var _this;
export default {
  name: "Menu",
  data() {
    return {
      activeMenu: '',
      menuList: getMenuList(),
      info: {},
      activeIndex: '',
      permission: ['1','2','3','4','5','6','8','7','9','10','11','12','13','14','15','16','17','18']
    }
  },
  mounted() {
    _this = this;
    _this.activeMenu = this.$route.path;
    _this.queryInfo();
  },
  watch: {
    '$route'(to) {
      _this.activeMenu = to.path;
      _this.initActiveIndex();
    }
  },
  methods: {
    gotoMenu(item) {
      if (this.activeMenu != item.url) {
        this.activeMenu = item.url;
        this.$router.push({path: item.url, query: {}})
      }
    },
    queryInfo() {
      this.$store.dispatch('user/getInfoAdmin').then((res1) => {
        _this.info = res1;
        _this.initActiveIndex();
      }).catch(() => {
      })
    },
    initActiveIndex() {
      debugger;
      this.activeIndex = null;
      this.menuList.forEach(item => {
        if (item.url && item.url === this.activeMenu) {
          this.activeIndex = item.id;
        }
        if (item.children) {
          item.children.forEach(menu => {
            if (menu.url === this.activeMenu) {
              this.activeIndex = menu.id;
            }
          })
        }
      });
      // if (this.activeIndex == null) {
      //   if (this.menuList[0].url !== undefined) {
      //     this.$router.push({path: this.menuList[0].url, query: {}});
      //   } else {
      //     this.$router.push({path: this.menuList[0].children[0].url, query: {}})
      //   }
      // }
    },
    logout() {
      this.$store.dispatch('user/logout');
      this.$router.push('/login');
    }
  }
}
</script>

<style lang="scss">
#menuBox {
  height: 100%;
  overflow: hidden;
  width: 100%;

  .header-box {
    height: 60px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
    overflow: hidden;
    color: #0070f7;

    .logo {
      float: left;
      width: 50%;
      overflow: hidden;
      height: 100%;
      line-height: 60px;
      font-size: 24px;
      padding-left: 30px;
      /*font-weight: bold;*/
    }

    .info-box {
      height: 60px;
      float: right;
      color: #ffffff;

      .head-img {
        height: 30px;
        width: 30px;
        border-radius: 100%;
        overflow: hidden;
        float: right;
        margin-top: 20px;
        border: 1px solid rgb(233, 233, 233);
      }

      .user-name-label {
        height: 100%;
        font-size: 16px;
        color: rgb(170, 170, 170);
        margin-left: 20px;
        float: right;
        line-height: 70px;
      }

      .btn-logout {
        border-radius: 5px;
        /*border: 1px solid rgb(167, 210, 249);*/
        color: rgb(0, 153, 255);
        background-color: rgba(236, 245, 255, 1);
        margin-left: 15px;
        margin-top: 20px;
        margin-right: 20px;
        float: right;
        padding: 6px 10px;
        cursor: pointer;
      }
    }
  }

  .system-menu-box {
    display: flex;
    background: #2b66e7;
  }

  .system-menu-box > div {
    display: inline;
    padding: 10px 10px;
    height: 30px;
    line-height: 30px;
    font-size: 18px;

    text-align: center;
    cursor: pointer;
    color: #fff;
    margin: 10px 0px 0px 50px;
    border-bottom: 5px solid rgba(255, 208, 75, 0);
  }

  .system-menu-box > div:first-child {
    margin-left: 20px;
  }

  .system-menu-box > div:hover, .system-menu-box > div.active {
    border-bottom: 5px solid rgb(255, 208, 75);
  }

  .el-menu-item-group__title {
    background: #2b66e7 !important;
    padding: 0px !important;
  }

  .el-menu {
    border: 0px;
  }

  .el-menu-item-group {
    .el-menu-item {
      color: #ddd7d7;
    }

    .el-menu-item.is-active {
      color: #fff !important;
    }
  }

  .el-menu-item-group:hover {
    background: #eeeeee;
    color: #fff !important;
  }

  .menu-box {
    width: 250px;
    height: calc(100% - 60px);
    //background: #2780ff;
    background: #3F5FD0;
    float: left;

    overflow-y: auto;

    .system-title {
      height: 70px;
      line-height: 70px;
      font-size: 22px;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
      background: #2780ff;
    }


    ul {
      background: rgba(42, 70, 170, 0);

      .el-menu-item:hover {
        background: #1c4ec8;
      }

      .el-menu-item.is-active {
        background: #1c4ec8;
        color: #ffffff;

        span {
          color: #ffffff;
        }
      }

      .el-submenu.is-active .el-submenu__title i, .el-submenu.is-active .el-submenu__title span {
        color: #ffffff !important;
      }

      li {
        .el-menu {
          background: #2157cd;

          li {
            background: #2157cd;
          }
        }

        span {
          color: rgba(255, 255, 255, 0.76);
        }

        i {
          color: rgba(255, 255, 255, 0.76);
        }

        .el-submenu__title {
          i {
            color: rgba(255, 255, 255, 0.76);
          }

          span {
            color: rgba(255, 255, 255, 0.76);
          }
        }
      }

      li:hover {

        .el-submenu__title {
          background: rgba(0, 0, 0, 0);
        }
      }

    }
  }

  .content-box {
    float: left;
    width: calc(100% - 13.02083vw);
    height: 100%;
    display: block;
    background: #F0F2F5;
    //background: rgb(240, 242, 245);

    .menu-title {
      width: 100%;
      /*background: #FFFFFF;*/
      height: 55px;
      line-height: 55px;
      /*border-top: 1px solid rgb(233, 233, 233);*/
      /*border-bottom: 1px solid rgb(233, 233, 233);*/
      padding: 0 20px;
      font-size: 18px;
      font-weight: bold;
      color: #4E5054;
    }
  }

  .content-box > div {
    width: 100%;
  }
}

.el-badge__content.is-fixed{
  top: 20px!important;
}
.notice-item{
  padding-right: 20px;
  .title{
    width: 100%;
    font-size: 15px;
    color: #333333;
    font-weight: 500;
    padding: 10px 10px 5px 10px;
    cursor: pointer;
  }
  .new-box{
    color: #f56c6c;
    background: #fef0f0;
    border-color: #fbc4c4;
    font-size: 12px;
    padding: 0 5px;
    height: 20px;
    line-height: 20px;
    margin-right: 3px;
    border-radius: 2px;

  }
  .create-time{
    width: 100%;
    color: #999999;
    padding: 5px 10px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
